<template>
  <div id="articles-lists">
    <div v-for="(chunk, index) in articles" :key="index">
      <ClusteredArticles :articles="chunk" />
      <div
        v-for="promotedSection in promotedArticles"
        :key="promotedSection.title"
      >
        <PromotedArticles
          v-if="!shouldShowErrorMessage && promotedSection.position === index + 1"
          :data="promotedSection"
          :isMobile="isMobile"
        />
      </div>
    </div>
    <div v-if="loadingArticles" class="spinner my-3"></div>
    <h3 class="no-matching-articles" v-if="shouldShowErrorMessage"> {{ translate('bgNoMatchingArticles', undefined) }}</h3>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ClusteredArticles from '@/components/ClusteredArticles.vue'
import PromotedArticles from '@/components/PromotedArticles.vue'
import { getQueryParams, cleanQueryParams, isEmptyObject } from '@/infrastructure/Utils'
import { translate } from 'rhg-vue-common'

export default {
  components: {
    PromotedArticles,
    ClusteredArticles
  },
  data () {
    return {
      isMobile: null
    }
  },
  async mounted () {
    const cleanedQueryParams = cleanQueryParams(getQueryParams(window.location.search))
    this.setInfiniteScroll()

    if (!isEmptyObject(cleanedQueryParams)) {
      await this.$store.commit('setSelectedTag', cleanedQueryParams.tag)
    }

    await this.$store.dispatch('getArticles')

    this.setSeoElements()

    window.addEventListener('resize', this.resizeHandler)
  },
  computed: {
    ...mapState(['articles', 'promotedArticles', 'selectedTag', 'tagList', 'loadingArticles', 'filters', 'totalPages']),
    ...mapGetters(['shouldShowErrorMessage', 'getSelectedKeyword', 'getSelectedTag'])
  },
  methods: {
    translate,
    resizeHandler () {
      this.isMobile = document.body.clientWidth < 980
    },
    setInfiniteScroll () {
      window.onscroll = async () => {
        const bottomOfWindow = document.documentElement.scrollTop > document.getElementsByClassName('entity-article-list')[0].scrollHeight
        if (bottomOfWindow && (this.filters.offset + 1 <= this.totalPages) && !this.loadingArticles) {
          this.$store.commit('setLoadingArticles', true)
          this.$store.commit('setOffset', this.filters.offset + 1)
          await this.$store.dispatch('getArticles')
        }
      }
    },
    setTitle () {
      const tag = this.getSelectedKeyword ? this.getSelectedKeyword.description : this.getSelectedTag

      document.title = `${document.title}${tag ? ' - ' : ''}${tag || ''}`
    },
    setButtonText () {
      const tag = this.getSelectedKeyword ? this.getSelectedKeyword.description : this.getSelectedTag

      const button = document.querySelector('.hero-article__tag-header-button')

      button.innerHTML = `${tag || ''}${button.innerHTML}`

      button.classList.remove('d-none')
    },
    setSeoElements () {
      this.setTitle()
      this.setButtonText()
    }
  }
}
</script>
<style>
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #c20808;
  margin: auto;
  animation: spin 1s ease infinite;
}

.no-matching-articles {
  font-size: 1.6rem;
  margin: 1.6rem 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

</style>
